import { addNavMenuSection } from '@vendure/admin-ui/core';
import { Permission } from './generated-types';

export default [
  addNavMenuSection({
    id: 'teams',
    label: 'Teams',
    items: [
      {
        id: 'teams',
        label: 'Teams',
        routerLink: ['/extensions/teams'],
        icon: 'users',
      },
      {
        id: 'team-members',
        label: 'Team Members',
        routerLink: ['/extensions/members'],
        icon: 'user',
      },
    ],
    requiresPermission: Permission.ReadTeams,
  }),
];
